import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Alert, Button } from 'antd';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(_error: Error, _errorInfo: ErrorInfo): void {
    // UI fallback is shown via getDerivedStateFromError
  }

  render(): ReactNode {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <Alert
          type="error"
          message="Something went wrong"
          description={this.state.error.message}
          showIcon
          action={
            <Button
              size="small"
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              Try again
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}
